module.exports = __webpack_public_path__ + "img/budget-comparative.cd644c00.svg";